import Image from 'next/image';
import React from 'react';

import AdminHomeTable from './AdminHomeTable';
import HeadingV2 from '../../shared/HeadingV2';
import { ArrowFaq } from '../../../../assets';
import { AdminHomeTableData } from '../../../utils/data';

const AdminLandingPage = () => {
  return (
    <>
      <div>
        <div className='relative overflow-hidden pb-20'>
          <div className='flex justify-center'>
            <div className='px-10 lg:px-24 pt-14 flex flex-col gap-y-10'>
              <span>
                <HeadingV2 heading='Super Admin Panel' />
              </span>
              <div className='text-2xl text-black pt-10'>
                Welcome to the super admin panel{' '}
              </div>
              <div className=''>
                <AdminHomeTable data={AdminHomeTableData} />
              </div>
            </div>
          </div>
          <span className=' absolute top-20 xl:top-[2%] translate-x-12 right-0'>
            <span className='w-36 md:w-44 lg:w-60 '>
              <Image
                src={ArrowFaq}
                alt='ArrowFaq'
                className='w-36 md:w-44 lg:w-60'
              />
            </span>
          </span>
        </div>
      </div>
    </>
  );
};

export default AdminLandingPage;
